import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import { Button, Clear, Success } from 'basic-components';

import './FormulaAdded.scss';

const FormulaAdded = ({ onClose, addressLocal, onEdit }) => {
  const timeoutRef = useRef()

  useEffect(() => {
    timeoutRef.current = setTimeout(onClose, 10000)

    return () => {
      clearTimeout(timeoutRef.current)
    }
  }, [addressLocal, onClose])

  return (
    <div className="formula-added">
        <div className="formula-added__left">
          <Success
              bgColor="green-grinch"
              color="white-base"
              height={16}
              width={16}
          />
          <p className="formula-added__left__title">
            Formula added sucesfully
          </p>
        </div>
        <div className="formula-added__right">
          <div 
              className="formula-added__right__edit"
              onClick={onEdit}
          >
            <Button variant="text">
              Edit call
            </Button>
          </div>
          <div 
              className="formula-added__right__clear"
              onClick={onClose}
          >
            <Clear
                color="grey-dark"
                height={12}
                width={12}
            />
          </div>
        </div>
    </div>
  )
}

FormulaAdded.defaultProps = {
  addressLocal: undefined
}

FormulaAdded.propTypes = {
  addressLocal: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
}

export default FormulaAdded;